module.exports = __webpack_public_path__ + "static/media/cocktail.be3c52e4.svg";